import type { Environment } from './types';

// 开发环境配置
const devEnvironment: Environment = {
  featureTag: '',
  AMSCashierPaymentEnvironment: 'sandbox',
  officialWebsite: 'https://localhost:3001',
  // 开发环境：30天
  serviceRatingTimeLimit: 30 * 24 * 60 * 60 * 1000,
  h5Url: 'https://localhost:3000',
};

export default devEnvironment;
